import { useCallback, useMemo, VoidFunctionComponent } from 'react';
import CountUp from 'react-countup';
import { useTheme } from 'styled-components';
import { formatCurrency, formatNumber } from 'lib/intl';
import { CurrencyCounterProps } from './types';

export const NumberCounter: VoidFunctionComponent<CurrencyCounterProps> = props => {
  const { currency = false, value, ...rest } = props;

  // Retrieve application theme
  const theme = useTheme();

  // Calculate animation duration
  const duration = useMemo(() => parseInt(theme.transition.slow) / 1000, [theme.transition.slow]);

  /**
   * Handle formatting currency values
   *
   * @param {number} value Source value
   */
  const handleFormat = useCallback(
    (value: number) =>
      currency ? formatCurrency(value).toLocaleString() : formatNumber(value).toLocaleString(),
    [currency],
  );

  return (
    <CountUp
      decimals={currency ? 2 : 0}
      duration={duration}
      end={value}
      formattingFn={handleFormat}
      preserveValue={true}
      {...rest}
    />
  );
};
